import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Box from '../components/Box'
import SaleList from '../components/SaleList'
import ErrorMessage from '../components/ErrorMessage'
import PropertyLabel from '../components/PropertyLabel'

// view specific styles
import '../styles/SalesView.css'

import SalesPlots from '../components/SalesPlots'
import SalesFilterForm from '../forms/SalesFilterForm'
import MonthYearPickerForm from '../forms/MonthYearPickerForm'
import { fetchSales, fetchSalesCSV, fetchSalesExcel } from '../actions/sales'

class SalesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showMonthlyReport: false,
      showFilters: true,
    }

    this.handleSalesCSV = this.handleSalesCSV.bind(this)
    this.handleSalesExcel = this.handleSalesExcel.bind(this)
    this.toggleMonthlyReport = this.toggleMonthlyReport.bind(this)
    this.toggleFilters = this.toggleFilters.bind(this)
  }

  toggleMonthlyReport() {
    this.setState({ showMonthlyReport: !this.state.showMonthlyReport })
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters })
  }

  calculatePercentageSales(type) {
    const { sales } = this.props
    if (!sales) return '0.00'
    let totalSales = 0
    let totalMethod = 0
    sales.forEach(sale => {
      if (sale.Amount >= 0) {
        if (sale.PaymentMethod === type) totalMethod++
        totalSales++
      } else if (sale.Amount < 0) {
        if (sale.PaymentMethod === type) totalMethod--
        totalSales--
      }
    })
    return ((totalMethod / totalSales) * 100).toFixed(2)
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10)
    this.props.fetchSales('', '', today, today, '', '', '', 'createdAt')
  }

  computeSalesTotals() {
    const { sales } = this.props

    if (!sales) {
      return
    }

    const itemIndices = new Map([
      ['LOCKERBASIC', 0],
      ['LOCKERBASICXL', 1],
      ['LOCKERCHARGER', 2],
      ['LOCKERCHARGERXL', 3],
      ['TUMBONAS', 4],
      ['FLOTADORES', 5],
      ['FLOTADORESHALFDAY', 6],
      ['FASTPASS', 7],
      ['VWPACK', 8],
      ['VWLAY', 9],
      ['VWGO', 10]
    ])

    let total = 0

    let totalsPerMethod = new Map([
      ['CASH', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TPV', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TOKEN', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['RFID', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]]
    ])

    let amount = 0

    let amountsPerMethod = new Map([
      ['CASH', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TPV', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TOKEN', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['RFID', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]]
    ])

    let qtyPerMethod = new Map([
      ['CASH', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TPV', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['TOKEN', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]],
      ['RFID', [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]]
    ])


    let totalsPerItem = new Map([
      ['LOCKERBASIC', 0],
      ['LOCKERBASICXL', 0],
      ['LOCKERCHARGER', 0],
      ['LOCKERCHARGERXL', 0],
      ['TUMBONAS', 0],
      ['FLOTADORES', 0],
      ['FLOTADORESHALFDAY', 0],
      ['FASTPASS', 0],
      ['VWPACK', 0],
      ['VWLAY', 0],
      ['VWGO', 0]
    ])

    for (let sale of sales) {
      let totalsPerSaleMethod = totalsPerMethod.get(sale.PaymentMethod)
      let amountsPerSaleMethod = amountsPerMethod.get(sale.PaymentMethod)
      let qtyPerSaleMethod = qtyPerMethod.get(sale.PaymentMethod)

      if (sale.Items) {
        for (let item of sale.Items) {
          let itemTotal = item.qty * item.price
          let itemAmount = item.qty * item.price

          if (item.qty > 1) {
            total += (itemTotal / item.qty)

            totalsPerSaleMethod[itemIndices.get(item.item)] += (itemTotal / item.qty)
            totalsPerItem.set(item.item, totalsPerItem.get(item.item) + (itemTotal / item.qty))

            amount += (itemAmount / item.qty)
            amountsPerSaleMethod[itemIndices.get(item.item)] += (itemAmount / item.qty)

          } else {
            total += itemTotal

            totalsPerSaleMethod[itemIndices.get(item.item)] += itemTotal
            totalsPerItem.set(item.item, totalsPerItem.get(item.item) + itemTotal)

            amount += itemAmount
            amountsPerSaleMethod[itemIndices.get(item.item)] += itemAmount
          }

          qtyPerSaleMethod[itemIndices.get(item.item)] += item.qty

        }
      }

      amountsPerMethod.set(sale.PaymentMethod, amountsPerSaleMethod)
      totalsPerMethod.set(sale.PaymentMethod, totalsPerSaleMethod)
      qtyPerMethod.set(sale.PaymentMethod, qtyPerSaleMethod)
    }

    return {
      total: total,
      totalsPerMethod: totalsPerMethod,
      totalsPerItem: totalsPerItem,
      amount: amount,
      amountsPerMethod: amountsPerMethod,
      qtyPerMethod: qtyPerMethod
    }
  }

  computeTotalSinIVA() {
    const { sales } = this.props
    if (!sales) return 0

    let totalSinIVA = 0

    for (let sale of sales) {
      const ivaRate = (sale.Customer && sale.Customer.Invoice_tax)
        ? parseFloat(sale.Customer.Invoice_tax)
        : 0

      let saleTotalConIVA = 0
      if (sale.Items) {
        for (let item of sale.Items) {
          let itemTotal = item.qty * item.price
          if (item.qty > 1) {
            saleTotalConIVA += itemTotal / item.qty
          } else {
            saleTotalConIVA += itemTotal
          }
        }
      }

      totalSinIVA += ivaRate > 0 ? saleTotalConIVA / (1 + ivaRate / 100) : saleTotalConIVA
    }

    return totalSinIVA
  }

  computeItemsTotals() {
    const { sales } = this.props

    let totalQty = 0

    let totalsPerItemQty = new Map([
      ['LOCKERBASIC', 0],
      ['LOCKERBASICXL', 0],
      ['LOCKERCHARGER', 0],
      ['LOCKERCHARGERXL', 0],
      ['TUMBONAS', 0],
      ['FLOTADORES', 0],
      ['FLOTADORESHALFDAY', 0],
      ['FASTPASS', 0],
      ['VWPACK', 0],
      ['VWLAY', 0],
      ['VWGO', 0]
    ])

    for (let sale of sales) {
      for (let item of sale.Items) {
        let itemTotal = item.qty

        totalQty += itemTotal
        totalsPerItemQty.set(item.item, totalsPerItemQty.get(item.item) + itemTotal)
      }
    }

    return {
      totalQty: totalQty,
      totalsPerItemQty: totalsPerItemQty
    }
  }

  handleSalesCSV() {
    const { fetchSalesCSV, form } = this.props

    fetchSalesCSV(form.SalesFilterForm.values.Machine,
      form.SalesFilterForm.values.Customer,
      form.SalesFilterForm.values.StartDate,
      form.SalesFilterForm.values.EndDate)
  }

  handleSalesExcel() {
    const { fetchSalesExcel, form } = this.props

    fetchSalesExcel(form.SalesFilterForm.values.Machine,
      form.SalesFilterForm.values.Customer,
      form.SalesFilterForm.values.StartDate,
      form.SalesFilterForm.values.EndDate,
      form.SalesFilterForm.values.Country,
      form.SalesFilterForm.values.Category,
      form.SalesFilterForm.values.PaymentMethod)
  }

  renderSalesTotals() {
    const { sales, error, loading, auth } = this.props

    if (auth.type === 'LIMITED') {
      return null
    }

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!sales || loading) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    let totals = this.computeSalesTotals()
    let totalsQty = this.computeItemsTotals()
    let totalSinIVA = this.computeTotalSinIVA()

    return (
      <>
        <div className="sales-kpi-row">
          <div className="sales-kpi-card income-day">
            <div className="kpi-icon"><i className="fas fa-euro-sign"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Total Ventas</div>
              <div className="kpi-value">{`${totals.total.toFixed(2)} €`}</div>
            </div>
          </div>
          <div className="sales-kpi-card income-day">
            <div className="kpi-icon"><i className="fas fa-file-invoice"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Total Ventas Sin IVA</div>
              <div className="kpi-value">{`${totalSinIVA.toFixed(2)} €`}</div>
            </div>
          </div>
          <div className="sales-kpi-card total">
            <div className="kpi-icon"><i className="fas fa-coins"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">CASH</div>
              <div className="kpi-value">{`${this.calculatePercentageSales('CASH')}%`}</div>
            </div>
          </div>
          <div className="sales-kpi-card time">
            <div className="kpi-icon"><i className="fas fa-credit-card"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">TPV</div>
              <div className="kpi-value">{`${this.calculatePercentageSales('TPV')}%`}</div>
            </div>
          </div>
          <div className="sales-kpi-card green-block">
            <div className="kpi-icon"><i className="fas fa-cubes"></i></div>
            <div className="kpi-content">
              <div className="kpi-label">Unidades</div>
              <div className="kpi-value">{totalsQty.totalQty}</div>
            </div>
          </div>
        </div>
        <div className="sales-table-card">
          <div className="table-responsive">
            <table className="table table-sm table-stripped">
              <thead className="thead-dark">
                <tr>
                  <th scope="col"><h6 className="text-white">PRODUCTO</h6></th>
                  <th scope="col"><h6 className="text-white">CASH ({this.calculatePercentageSales('CASH')}%)</h6></th>
                  <th scope="col"><h6 className="text-white">TPV ({this.calculatePercentageSales('TPV')}%)</h6></th>
                  <th scope="col"><h6 className="text-white">MANUAL ({this.calculatePercentageSales('TOKEN')}%)</h6></th>
                  <th scope="col"><h6 className="text-white">PULSERA ({this.calculatePercentageSales('RFID')}%)</h6></th>
                  <th scope="col"><h6 className="text-white">TOTAL</h6></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row"><h6 className="text-left text-vw-dark">PACK</h6></th>
                  <th scope="row">{`${totals.amountsPerMethod.get('CASH')[8].toFixed(2)} € / ${totals.qtyPerMethod.get('CASH')[8]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TPV')[8].toFixed(2)} € / ${totals.qtyPerMethod.get('TPV')[8]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TOKEN')[8].toFixed(2)} € / ${totals.qtyPerMethod.get('TOKEN')[8]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('RFID')[8].toFixed(2)} € / ${totals.qtyPerMethod.get('RFID')[8]} u`}</th>
                  <th scope="row">{`${totals.totalsPerItem.get('VWPACK').toFixed(2)} € / ${totalsQty.totalsPerItemQty.get('VWPACK')} u`}</th>
                </tr>
                <tr>
                  <th scope="row"><h6 className="text-left text-vw-dark">LAY</h6></th>
                  <th scope="row">{`${totals.amountsPerMethod.get('CASH')[9].toFixed(2)} € / ${totals.qtyPerMethod.get('CASH')[9]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TPV')[9].toFixed(2)} € / ${totals.qtyPerMethod.get('TPV')[9]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TOKEN')[9].toFixed(2)} € / ${totals.qtyPerMethod.get('TOKEN')[9]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('RFID')[9].toFixed(2)} € / ${totals.qtyPerMethod.get('RFID')[9]} u`}</th>
                  <th scope="row">{`${totals.totalsPerItem.get('VWLAY').toFixed(2)} € / ${totalsQty.totalsPerItemQty.get('VWLAY')} u`}</th>
                </tr>
                <tr>
                  <th scope="row"><h6 className="text-left text-vw-dark">GO</h6></th>
                  <th scope="row">{`${totals.amountsPerMethod.get('CASH')[10].toFixed(2)} € / ${totals.qtyPerMethod.get('CASH')[10]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TPV')[10].toFixed(2)} € / ${totals.qtyPerMethod.get('TPV')[10]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TOKEN')[10].toFixed(2)} € / ${totals.qtyPerMethod.get('TOKEN')[10]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('RFID')[10].toFixed(2)} € / ${totals.qtyPerMethod.get('RFID')[10]} u`}</th>
                  <th scope="row">{`${totals.totalsPerItem.get('VWGO').toFixed(2)} € / ${totalsQty.totalsPerItemQty.get('VWGO')} u`}</th>
                </tr>
                <tr>
                  <th scope="row"><h6 className="text-left text-vw-dark">CHARGER</h6></th>
                  <th scope="row">{`${totals.amountsPerMethod.get('CASH')[2].toFixed(2)} € / ${totals.qtyPerMethod.get('CASH')[2]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TPV')[2].toFixed(2)} € / ${totals.qtyPerMethod.get('TPV')[2]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('TOKEN')[2].toFixed(2)} € / ${totals.qtyPerMethod.get('TOKEN')[2]} u`}</th>
                  <th scope="row">{`${totals.amountsPerMethod.get('RFID')[2].toFixed(2)} € / ${totals.qtyPerMethod.get('RFID')[2]} u`}</th>
                  <th scope="row">{`${totals.totalsPerItem.get('LOCKERCHARGER').toFixed(2)} € / ${totalsQty.totalsPerItemQty.get('LOCKERCHARGER')} u`}</th>
                </tr>
                <tr>
                  <th scope="row"><h5 className="text-left text-vw-dark">TOTALES</h5></th>
                  <th scope="row"><h5 className="text-vw-light">{`${totals.totalsPerMethod.get('CASH').reduce((acc, currVal) => acc + currVal).toFixed(2)} €`}</h5></th>
                  <th scope="row"><h5 className="text-vw-light">{`${totals.totalsPerMethod.get('TPV').reduce((acc, currVal) => acc + currVal).toFixed(2)} €`}</h5></th>
                  <th scope="row"><h5 className="text-vw-light">{`${totals.totalsPerMethod.get('TOKEN').reduce((acc, currVal) => acc + currVal).toFixed(2)} €`}</h5></th>
                  <th scope="row"><h5 className="text-vw-light">{`${totals.totalsPerMethod.get('RFID').reduce((acc, currVal) => acc + currVal).toFixed(2)} €`}</h5></th>
                  <th scope="row"><h5 className="text-vw-light">{`${totals.total.toFixed(2)} €`}</h5></th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
  }

  renderSalesStats() {
    const { role } = this.props
    if (role !== 'ADMIN') return null
    return (
      <Box title="Estadísticas" icon="chart-bar">
        <SalesPlots sales={this.props.sales} />
      </Box>
    )
  }

  renderSales() {
    const { sales, error, loading, auth } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!sales || loading) {
      return (<div class="spinner"><img src="/images/logo.png" alt="Logo" /></div>)
    }

    return (
      <div>
        {this.renderSalesStats()}
        <Box title="Listado (100 ventas por página)">
          <SaleList auth={auth} />
        </Box>
      </div>
    )
  }

  render() {
    const { role } = this.props.auth

    return (
      <div className="sales-admin-view">
        <div className="sales-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-chart-line mr-3"></i> Ventas
              </h1>
            </div>
            <div className="header-actions">
              {role === 'ADMIN' && (
                <button
                  className="btn btn-outline-primary mr-2"
                  onClick={this.toggleMonthlyReport}
                >
                  <i className="fas fa-calendar-alt mr-1"></i>Reporte Mensual
                </button>
              )}
              <button
                className="btn btn-outline-primary"
                onClick={this.toggleFilters}
              >
                {this.state.showFilters
                  ? <><i className="fas fa-chevron-up mr-1"></i>Ocultar filtros</>
                  : <><i className="fas fa-chevron-down mr-1"></i>Mostrar filtros</>
                }
              </button>
            </div>
          </div>
          {this.state.showMonthlyReport && (
            <div className="mt-2">
              <MonthYearPickerForm />
            </div>
          )}
        </div>
        {this.state.showFilters && (
          <div className="sales-filter-wrapper mb-3">
            <SalesFilterForm />
          </div>
        )}
        <div>{this.renderSalesTotals()}</div>
        {this.renderSales()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  sales: state.sales.sales,
  error: state.sales.error,
  loading: state.sales.loading,
  auth: state.auth,
  form: state.form,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchSales: bindActionCreators(fetchSales, dispatch),
  fetchSalesCSV: bindActionCreators(fetchSalesCSV, dispatch),
  fetchSalesExcel: bindActionCreators(fetchSalesExcel, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SalesView)


